export const FilterActionTypes = {
  SET_FILTERS: undefined,
};
